module.exports = __webpack_public_path__ + "img/fr4.ee4191b8.png";